import { Location, MonitoringServiceProviderLocation, USAddressCountry } from '../../../../api/models'
import { STREET_SUFFIX_MAP } from '../../../../constants'
import { hasValueDifference } from '../../../../utils/valueComparisonUtils'

export const isProfessionallyMonitored = (location: Location | undefined) => location?.monitoring?.serviceStatus?.professionalMonitoring?.isEnabled

export const normalizeStreetSuffix = (street: string | undefined | null): string => {
  if (!street) return ''
  return street.replace(/\b(\w+)$/, match => STREET_SUFFIX_MAP[match.toUpperCase()] || match)
}

export const getAddressDifferences = (
  location: Location | undefined,
  mspLocation: MonitoringServiceProviderLocation | undefined,
  enabled: boolean
) => {
  const isEnabled = !!mspLocation || enabled
  const mspAddress = mspLocation?.address
  const mspState = mspAddress?.country === USAddressCountry.US ? mspAddress.state : undefined
  const mspPostalCode = mspAddress?.country === USAddressCountry.US ? mspAddress.zipCode : mspAddress?.postalCode

  return {
    street1: hasValueDifference(normalizeStreetSuffix(location?.address?.street1), normalizeStreetSuffix(mspAddress?.street1), isEnabled),
    street2: hasValueDifference(location?.address?.street2, mspAddress?.street2, isEnabled),
    city: hasValueDifference(location?.address?.city, mspAddress?.city, isEnabled),
    state: hasValueDifference(location?.address?.state, mspState, isEnabled),
    postalCode: hasValueDifference(location?.address?.zip, mspPostalCode, isEnabled),
    county: hasValueDifference(location?.address?.county, mspAddress?.county, isEnabled),
    timeZone: hasValueDifference(location?.address?.timeZone, mspAddress?.timeZone, isEnabled),
    crossStreet: hasValueDifference(location?.address?.crossStreet, mspAddress?.crossStreet, isEnabled)
  }
}
